import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

const FormatTitre = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <EditableField
          field={format?.title}
          type="title"
          isEditor={isEditor}
          sx={{
            color:"text.black",
            fontSize:["26px", "42px", "42px", "46px"],
            textAlign:"center"
          }}
        />
        <EditableField
          field={format?.subTitle}
          type="subTitle"
          isEditor={isEditor}
          sx={{
            color:"text.subTitle",
            fontSize:["16px", "20px", "20px", "26px"],
            textAlign:"center",
            margin:"20px 0px",
          }}
        />
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={isEditor}
            type="button"
            field={format?.button?.text}
            sx={{}}
            onClick={() => {
              manageFormatResponse(format, [{ key: 'isDone', value: true }])
              manageSlide(1)
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatTitre
